import { useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import axios from "axios";
import { BASEURL } from "../../../utilites";
import PdfIcon from "../../../assets/img/pdf.jpg";
import DeleteIcon from "../../../assets/img/x.svg";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../Store/action";
import FileIconSvg from "../../../assets/img/onboarding-File.svg";
import { RiUpload2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const DriverLicense = ({
  setStep,
  userId,
  userFullname,
  isQuestionnaireCompleted,
  isMessageSent,
  isAppointmentBooked,
  isVerify,
  isVideoWatched,
  isPasswordChanged,
  isPdfDownloaded
}) => {
  const button = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [{ LoginData }] = useSelector((state) => [state.user]);
  const [documents, setDocuments] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploaded, setUploaded] = useState(false);

  const [alert, setAlert] = useState({
    password: false,
    newPassword: false,
    passwordRepeat: false,
    class: "danger",
    general: "",
  });

  const [errors, setErrors] = useState({
    documents: false,
    documentName: false,
    general: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (documents) {
      setUploading(true);

      button.current.disabled = true;
      if (errors.general !== "") setErrors({ errors, general: "" });

      // Create a new FormData instance
      const formData = new FormData();
      // Append all properties to FormData
      formData.append("documents", documents);
      formData.append("user_id", userId);
      formData.append("type", 1);
      formData.append("driver_license", true);
      formData.append("document_name", `${userFullname}-driver_license`);
      formData.append("lead_id", LoginData?.lead[0]?.id);

      try {
        await axios
          .post(`${BASEURL}/api/documents`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );

              setUploadProgress(progress);
            },
          })
          .then(() => {
            button.current.disabled = false;
            dispatch(
              allActions.user.ReGetUserData(() =>
                dispatch(allActions.dashboard.getAccountStatus())
              )
            );
            setAlert({
              class: "success",
              general: "Driver License uploaded successfully",
            });
            setUploaded(true);
            // setTimeout(() => {
            //   if (from === "todo-list") {
            //     document.querySelector(".uploadDriverLicenseModal").click();
            //   } else {
            //     if (isQuestionnaireCompleted && !isMessageSent) {
            //       setStep((prev) => prev + 2);
            //       return
            //     }else if(isQuestionnaireCompleted && isMessageSent) {
            //       setStep((prev) => prev + 3);
            //       return
            //     } else {
            //       setStep((prev) => prev + 1);
            //     }
            //   }
            // }, 3000);
          });
      } catch (error) {
        button.current.disabled = false;
        console.error(error.message);
        // Set general error
        if (errors.general === "")
          setErrors({
            errors,
            general: error?.response?.data?.message || error.message,
          });
      }
      // Reset the form
      setUploading(false);
      setUploadProgress(0);
    }
  };

  const changeURL = (file) => {
    if (file) {
      let objectUrl = URL.createObjectURL(file);
      if (file?.type === "application/pdf") {
        objectUrl = PdfIcon;
      }

      return objectUrl;
    }
  };
  return (
    <div className="d-flex flex-column justify-content-center align-items-center bg-white pb-2 pt-2 px-3">
      {!uploaded ? (
        <div className="w-100">
          <h2 className="text-center fw-bold text-primary mb-2">
            Upload Driver License
          </h2>
          <p className="text-center text-muted mb-4">
            Please provide a clear image of your driver license
          </p>

          {!uploading && (
            <div
              className="border-dashed rounded p-5 text-center mx-auto mb-4"
              style={{
                border: "2px dashed #a0a0ff",
                cursor: "pointer",
                width: "100%",
                maxWidth: "500px",
              }}
            >
              <div>
                {documents && !uploading ? (
                  <div className="text-center mb-4">
                    <div className="position-relative d-inline-block">
                      <img
                        onClick={(e) => {
                          e.stopPropagation();
                          setDocuments(null);
                        }}
                        src={DeleteIcon}
                        alt="delete"
                        style={{
                          width: "20px",
                          position: "absolute",
                          top: "-10px",
                          right: "-10px",
                          cursor: "pointer",
                        }}
                      />
                      <img
                        src={changeURL(documents)}
                        alt="preview"
                        style={{ maxHeight: "100px", borderRadius: "8px" }}
                      />
                    </div>
                  </div>
                ) : (
                  <img src={FileIconSvg} alt="File" />
                )}
              </div>
              <FileUploader
                classes="form-control file-upload mt-3"
                multiple={false}
                values={documents}
                handleChange={(files) => setDocuments(files)}
                name="documents"
                types={["PNG", "JPG", "PDF", "JPEG"]}
                onTypeError={() => setErrors({ ...errors, documents: true })}
              />
              <div className="mt-3 text-muted">
                Upload or drop your license file here
                <br />
                <small>Accepted file types: JPG, PNG, PDF</small>
              </div>
              <button
                className="btn btn-primary mt-3 px-4 py-2"
                onClick={handleSubmit}
                disabled={!documents || uploading}
                type="button"
              >
                <i className="bi bi-upload me-2" />
                <RiUpload2Line /> Upload File
              </button>
            </div>
          )}

          {uploading && (
            <div className="progress mb-3">
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{ width: `${uploadProgress}%` }}
                aria-valuenow={uploadProgress}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {uploadProgress}%
              </div>
            </div>
          )}

          {errors.general && (
            <div className="alert alert-danger">{errors.general}</div>
          )}

          {alert.general && (
            <div
              className={`alert alert-${alert.class} alert-dismissible fade show text-center`}
              role="alert"
            >
              {alert.general}
            </div>
          )}
        </div>
      ) : (
        <div className="text-center w-100">
          {documents && (
            <img
              src={changeURL(documents)}
              alt="preview"
              style={{ maxHeight: "100px", borderRadius: "8px" }}
            />
          )}
          <p className="text-muted mb-1 mt-3">
            {documents?.name || "Uploaded Document"}
          </p>
          <p className="fw-semibold" style={{ color: "#1d1bbf" }}>
            <span className="text-success me-2 mt-1">✔</span>
            Document Uploaded
          </p>
        </div>
      )}
      <div className="d-flex w-100 justify-content-between mt-4">
        <button
          className={`${
            uploading ||
            ( isAppointmentBooked &&
              isQuestionnaireCompleted &&
              isVerify &&
              isVideoWatched &&
              isPasswordChanged)
              ? " disabled"
              : " "
          } btn btn-outline-primary px-4`}
          type="button"
          disabled={
            uploading ||
            ( isAppointmentBooked &&
              isQuestionnaireCompleted &&
              isVerify &&
              isVideoWatched &&
              isPasswordChanged)
          }
          onClick={() => {
            setStep((prev) => prev - 1);
            navigate(
              `?lead=${LoginData?.lead?.[0]?.uuid}&customer=${LoginData?.uuid}&operator=${LoginData?.lead?.[0]?.userpro?.uuid}`,
              { replace: true }
            );
          }}
        >
          ← Back
        </button>

        <button
          ref={button}
          className="btn btn-primary px-4 text-white fw-semibold"
          onClick={() => {
            
             if (isQuestionnaireCompleted && !isMessageSent) {
              setStep((prev) => prev + 2);
              return;
            } else if(isQuestionnaireCompleted && isMessageSent && !isPdfDownloaded){
              setStep((prev) => prev + 3);
            } else if (isQuestionnaireCompleted && isMessageSent && isPdfDownloaded ) {
              setStep((prev) => prev + 4);
              return;
            } else {
              setStep((prev) => prev + 1);
            }
          }}
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default DriverLicense;
